var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCoordonnees = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.526,
    height: 23.765,
    viewBox: "0 0 23.526 23.765",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coordonnees",
    transform: "translate(-3426.28 -5840.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_214",
    "data-name": "Groupe 214",
    transform: "translate(3184.584 5425.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_66",
    "data-name": "Trac\\xE9 66",
    d: "M253.452,438.689c-2.7,0-5.4.006-8.106,0a3.574,3.574,0,0,1-3.573-2.862,3.528,3.528,0,0,1-.077-.753c0-4.008-.005-8.016,0-12.024a3.45,3.45,0,0,1,1.863-3.2q4.074-2.261,8.175-4.473a3.454,3.454,0,0,1,3.444.012q4.027,2.168,8.043,4.356a3.574,3.574,0,0,1,2,3.366q0,5.951,0,11.9a3.582,3.582,0,0,1-2.787,3.586,4.153,4.153,0,0,1-.972.088Zm0-1.567q4.029,0,8.057,0a2.016,2.016,0,0,0,2.137-2.131q0-5.975,0-11.951a1.986,1.986,0,0,0-1.091-1.861q-4.059-2.213-8.124-4.413a1.955,1.955,0,0,0-1.965,0q-4.054,2.2-8.1,4.4A1.969,1.969,0,0,0,243.267,423q0,6.024,0,12.049a2.169,2.169,0,0,0,.08.6,2.017,2.017,0,0,0,2.045,1.465Q249.419,437.125,253.447,437.122Z",
    transform: "translate(0 0)",
    fill: "#5471a9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_87",
    "data-name": "Groupe 87",
    transform: "translate(245.838 422.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_86",
    "data-name": "Groupe 86",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_67",
    "data-name": "Trac\\xE9 67",
    d: "M318.4,537.39a7.822,7.822,0,0,0-2.984-1.872,4.54,4.54,0,1,0-5.137,0A7.865,7.865,0,0,0,305,542.943h1.227a6.626,6.626,0,1,1,13.251,0H320.7A7.8,7.8,0,0,0,318.4,537.39Zm-5.553-2.3a3.313,3.313,0,1,1,3.313-3.313A3.317,3.317,0,0,1,312.85,535.09Z",
    transform: "translate(-304.997 -527.238)",
    fill: "#5471a9"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoordonnees, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/coordonnees.cc7d0d60.svg";
export { ForwardRef as ReactComponent };